module.exports = "https://www.gc-qa.gnp.com.mx/27c2b10fc9cabd6ad99406973505218c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/consultar-polizas/5.png
// module id = 1021
// module chunks = 0 1